import { useTranslation } from 'react-i18next';
import PercentPie from 'components/PercentPie';
import { formatProposalTotal } from '../share/model/helper/proposalPriceUtils';

interface ProposalFooterTotalsProps {
    totalAmount: number;
    rate: number;
    pricesInUsd: boolean;
    showVat: boolean;
    margin: { amount: number; percent: number | null } | null;
}

const ProposalFooterTotals = ({ totalAmount, rate, pricesInUsd, showVat, margin }: ProposalFooterTotalsProps) => {
    const { t, i18n } = useTranslation('Proposal');

    return (
        <div className="d-flex flex-wrap align-items-stretch gap-2">
            <div className="proposal-footer-total border rounded p-2 px-3 justify-content-center">
                <div className="proposal-footer-total-label text-muted">{t('edit.totalCostLabel')}</div>
                <div className="proposal-footer-total-value text-body-emphasis">
                    {formatProposalTotal(totalAmount, rate, pricesInUsd)}
                    {showVat ? (
                        <span className="badge bg-light-info text-info ms-1">
                            {t('edit.general.vatLabel')}
                        </span>
                    ) : null}
                </div>
            </div>
            {margin ? (
                <div className="proposal-footer-total border rounded p-2 px-3 justify-content-center">
                    <div className="proposal-footer-total-label text-muted">{t('edit.marginLabel')}</div>
                    <div className="proposal-footer-total-value text-body-emphasis d-flex flex-wrap align-items-center gap-2">
                        {formatProposalTotal(margin.amount, rate, pricesInUsd)}
                        {margin.percent === null ? (
                            <span className="text-muted">—</span>
                        ) : (
                            <PercentPie
                                percent={margin.percent}
                                size="sm"
                                label={`${margin.percent.toLocaleString(i18n.language === 'ua' ? 'uk' : i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`}
                            />
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default ProposalFooterTotals;
